import { jsx as _jsx } from "react/jsx-runtime";
import { Link as RouterLink } from 'react-router-dom';
import { EM_DASH } from 'libs.constants';
import { useLocalizeMessage, Link, Badge, Dropdown, useDialog } from 'libs.nucleus';
export const useDataViewsColumns = ({ archiveView }) => {
    const translate = useLocalizeMessage();
    const dialog = useDialog();
    const onArchiveView = async (view) => {
        const ok = await dialog.open({
            title: translate('Confirm archival?'),
            body: translate('Are you sure you want to archive this dataset? Confirming will remove this view from the main list and make it no longer editable. You can still view it via the "Show archived" filter.'),
            actionButtons: [{ isDestructive: true, label: translate('Yes, archive') }, { label: translate('No, cancel') }],
        });
        if (ok) {
            archiveView(view);
        }
    };
    const getStatusBadgeVariant = (status) => {
        switch (status) {
            case 'PUBLISHED':
                return 'success';
            case 'DRAFT':
                return 'warning';
            case 'IN_REVIEW':
                return 'incomplete';
            default:
                return 'common';
        }
    };
    const getStatusLabel = (status) => {
        switch (status) {
            case 'DRAFT':
                return translate('In Progress');
            case 'IN_REVIEW':
                return translate('In Review');
            case 'PUBLISHED':
                return translate('Ready for Use');
            default:
                return status;
        }
    };
    return [
        {
            header: translate('Name'),
            accessorKey: 'name',
            enableSorting: true,
            cell: (value) => {
                const view = value.row.original;
                return (_jsx(Link, { LinkComponent: RouterLink, to: `/library/data-views/${view.id}`, children: value.getValue() }));
            },
            size: 250,
        },
        {
            header: translate('Description'),
            accessorKey: 'description',
            accessorFn: (view) => view.metadata?.description || EM_DASH,
            enableSorting: false,
            size: 400,
        },
        {
            header: translate('Version'),
            accessorKey: 'version',
            enableSorting: true,
            cell: ({ row }) => _jsx(Badge, { label: `v${row.original.version}` }),
            size: 120,
        },
        {
            header: translate('Status'),
            accessorKey: 'status',
            enableSorting: true,
            size: 150,
            cell: (value) => {
                const status = value.getValue();
                return _jsx(Badge, { label: getStatusLabel(status), variant: getStatusBadgeVariant(status) });
            },
        },
        {
            header: '',
            accessorKey: 'id',
            size: 50,
            cell: ({ row }) => {
                const view = row.original;
                const isArchived = view.active === false;
                // Don't show actions menu for archived views
                if (isArchived) {
                    return null;
                }
                const items = [
                    {
                        content: translate('Archive'),
                        id: 'archive-' + view.id,
                        onClick: () => onArchiveView(view),
                    },
                ];
                return _jsx(Dropdown, { variant: 'kebab', position: 'bottom-end', items: items });
            },
            enableSorting: false,
        },
    ];
};
